/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsx jsx */
import React, { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { N0, N50A, N60A, N900 } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
const CSS_THEME_BACKGROUND = '--theme-background';
const CSS_THEME_COLOR = '--theme-color';
const CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const containerStyles = css({
  boxSizing: 'content-box',
  maxWidth: `${8 * 56}px`,
  maxHeight: `${8 * 56}px`,
  padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
  zIndex: layers.dialog(),
  background: `var(${CSS_THEME_BACKGROUND})`,
  borderRadius: "var(--ds-border-radius, 3px)",
  boxShadow: `var(${CSS_THEME_BOX_SHADOW})`,
  color: `var(${CSS_THEME_COLOR})`,
  '&:focus': {
    outline: 'none'
  }
});
/**
 * __Container__
 *
 * A container is used as a styled wrapper around the contents of an inline dialog.
 * Note that the styles here are merged with the style prop that comes from the popper.js library.
 *
 */
export const Container = /*#__PURE__*/forwardRef(({
  children,
  onBlur,
  onClick,
  onFocus,
  style,
  testId
}, ref) => {
  return jsx("div", {
    css: containerStyles,
    "data-testid": testId,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    ref: ref,
    style: {
      [CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${N0})`,
      [CSS_THEME_COLOR]: `var(--ds-text, ${N900})`,
      [CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${N50A}, 0 0 1px ${N60A}`})`,
      ...style
    }
  }, children);
});